import { createSlice } from '@reduxjs/toolkit';

const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        modal2Open: false,
    },
    reducers: {
        setModal2Open: (state, action) => {
            state.modal2Open = action.payload;
        },
    },
});

export const { setModal2Open } = modalSlice.actions;
export default modalSlice.reducer;
